<template>
	<template v-if="showsIntro">
		<!-- <CoLtdIntroPage></CoLtdIntroPage> -->
		<CoLtdIntroEmbed></CoLtdIntroEmbed>
	</template>
	<!-- <template v-else-if="showsConfigGuide">
		<ConfigGuidePage :domain="guideDomain"></ConfigGuidePage>
	</template> -->
	<template v-else>
		<router-view v-if="load" />
	</template>
</template>
<script>
import {
	validateURLStringIfNeedsRedirect,
	checkIfWWWCOLTDDomain,
	getCoLtdDomain,
} from "@/utils/utilities.js";
// import CoLtdIntroPage from "@/components/intro/CoLtdIntroPage.vue";
import CoLtdIntroEmbed from "@/components/intro/CoLtdIntroEmbed.vue";
import axios from "axios";
import wx from "weixin-js-sdk"; // 引入wxjs
import { processWebsiteBasicInfo } from "@/utils/website_info_processor.js";

// import ConfigGuidePage from "@/components/intro/ConfigGuide.vue";

export default {
	setup(props) {
		props;
		// console.log("app.vue setup");
	},
	mounted() {},
	data() {
		return {
			load: false,
			showsIntro: false,
			showsConfigGuide: false,
			guideDomain: "",
		};
	},
	created() {
		this.judgeDigitalgateRedirection();

		// 基础配置
		this.$emitter.on("didUpdateHeadMeta", (e) => this.updateWxShareInfo(e));

		// 请求全局基础信息
		this.requestWxConfig();
		this.requestWebsiteBasicInfo();
	},
	computed: {
		websiteId() {
			return this.$store.state.websiteId;
		},
	},
	watch: {
		websiteId(newVal, oldVal) {
			if (newVal > 0 && oldVal == 0) {
				// 第一次触发
				this.sendInitialAnalyst();
			}
		},
	},
	methods: {
		// 请求到website id以后，更新一下
		sendInitialAnalyst() {
			// console.log("send initial: " + this.websiteId);
			// if (this.websiteId > 0 && !process.env.NODE_ENV == "development") {
			if (
				this.websiteId > 0 &&
				(!(process.env.NODE_ENV == "development") || this.websiteId == 394210)
			) {
				const _ga = window._ga;
				_ga.url = "https://wei.ltd.com/analyst";
				_ga.params["wi"] = "3";
				_ga.params["ui"] = "0";
				_ga.init(this.websiteId);
			}
		},
		judgeDigitalgateRedirection() {
			const urlString = window.location.href;
			this.guideDomain = getCoLtdDomain(urlString);
			const testShowConfig = false;
			const testShowIntro = false;
			if (testShowConfig) {
				// 测试
				this.showsConfigGuide = true;
			} else if (testShowIntro) {
				this.showsIntro = true;
			} else {
				// if host matches www.xxx.co.ltd, remove www and jump.
				if (checkIfWWWCOLTDDomain(urlString)) {
					this.showsIntro = true;
				} else {
					let redirect = validateURLStringIfNeedsRedirect(window.location.href);

					// console.log(redirect);

					// redirect = validateURLStringIfNeedsRedirect("https://www.aiming.co.ltd");
					// console.log(redirect);

					if (redirect.redirect) {
						window.location.replace(redirect.urlString);
					} else {
						this.load = true;
					}
				}
			}
		},
		updateWebsiteBasicInfo(info) {
			this.$store.commit("updateWebsiteBasicInfo", info);
			if (info?.website_id) {
				this.$store.commit("updateWebsiteId", info?.website_id);
			}
		},
		requestWebsiteBasicInfo() {
			const that = this;
			const infoURL = "/api/digitalgate/info?data=info";
			axios
				.get(infoURL, { params: {} })
				.then((response) => {
					const responseData = response.data?.data?.info;
					const basicInfo = processWebsiteBasicInfo(responseData);
					that.updateWebsiteBasicInfo(basicInfo);

					// first time analyst
				})
				.catch((error) => {
					error;
				});
		},
		requestWxConfig() {
			// 接口2
			// https://ltd.com/shop/frontend/user/getShareLink?url=https://ltd.com/article_detail/5298047725768533

			// ajax request
			const url =
				"/shop/frontend/user/getShareLink?url=" + document.location.href;
			axios
				.get(url, { params: {} })
				.then((response) => {
					const jsInfoObject = response.data?.data;
					// console.log(jsInfoObject);

					this.setupWxShareFromShareLink(jsInfoObject);
				})
				.catch((error) => {
					error;
				});
		},
		requestWxConfig_old() {
			// ajax request
			const url = "/api/digitalgate/config";
			axios
				.get(url, { params: {} })
				.then((response) => {
					// that.loading = false;
					const jsinfoStr = response.data?.data?.wxconfig?.jsinfo;
					// console.log(jsinfoStr);

					if (jsinfoStr) {
						const jsInfoObject = JSON.parse(jsinfoStr);
						// console.log(jsInfoObject);
						// this.$store.commit("updateWxShareConfig", jsInfoObject);
						this.setupWxShare(jsInfoObject);
					}
				})
				.catch((error) => {
					error;
				});
			// update: this.$store.commit('updateWxShareConfig', {});
		},
		// 当$store.state.wxShareInfo更新时，通过一层监听来更新分享数据
		updateWxShareInfo(info) {
			// useHead好像nextTick也不能获取到，暂时直接发送shareInfo来更新了。

			// console.log(info);
			wx.ready(function() {
				// console.log("update wx");
				wx.updateTimelineShareData({
					title: info.title, // 分享标题
					link: info.url, // 分享链接，可以不是当前页面，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
					imgUrl: info.image,
					success: function() {
						// 用户确认分享后执行的回调函数
					},
					cancel: function() {
						// 用户取消分享后执行的回调函数
					},
				});
				wx.updateAppMessageShareData({
					title: info.title, // 分享标题
					desc: info.description,
					link: info.url, // 分享链接，可以不是当前页面，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
					imgUrl: info.image,
					type: "link", // 分享类型,music、video或link，不填默认为link
					success: function() {
						// 用户确认分享后执行的回调函数
					},
					cancel: function() {
						// 用户取消分享后执行的回调函数
					},
				});
			});
		},
		setupWxShareFromShareLink(config) {
			wx.config({
				debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
				appId: config.appid, // 必填，公众号的唯一标识
				timestamp: config.timestamp, // 必填，生成签名的时间戳
				nonceStr: config.noncestr, // 必填，生成签名的随机串
				signature: encodeURIComponent(config.signature), // 必填，签名
				jsApiList: [
					"updateTimelineShareData",
					"updateAppMessageShareData",
					"onMenuShareTimeline",
					"onMenuShareAppMessage", //分享给好友
					"onMenuShareQQ",
					"onMenuShareWeibo",
					"onMenuShareQZone",
				], // 必填，需要使用的JS接口列表
			});
		},
		setupWxShare(config) {
			config.debug = false;
			// config.debug = true;
			// config.url = document.location.protocol + "//" + document.location.host;

			// wx.error(function(res) {

			// 	// console.log("wx config error");
			// 	// console.log(res);
			// });
			// wx.ready(function() {
			// 	// console.log("ready");
			// });

			wx.config(config);
		},
	},
	components: {
		// CoLtdIntroPage,
		CoLtdIntroEmbed,
		// ConfigGuidePage,
	},
};
</script>

<style>
#app {
	font-family: Avenir, Helvetica, Arial, sans-serif;
	-webkit-font-smoothing: antialiased;
	-moz-osx-font-smoothing: grayscale;
	/* text-align: center; */
	color: #2c3e50;
	/* background: white; */
}

#nav {
	padding: 30px;
}

#nav a {
	font-weight: bold;
	color: #2c3e50;
}

#nav a.router-link-exact-active {
	color: #42b983;
}
</style>
